export default __webpack_public_path__ + "static/media/spring-difference.faaa0d1d.png";